import { useGetAgenda } from "@/hooks/queryHooks/agendaHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { useUserStore } from "@/stores/userStore";
import { Link } from "react-router-dom";

export const AgendaSummaryItem = ({
  tenantId,
  agendaId,
}: {
  tenantId: string;
  agendaId: string;
}) => {
  const activeTeam = useUserStore((s) => s.activeTeam);
  const { data: agenda } = useGetAgenda(tenantId, agendaId);
  const path =
    agendaId && activeTeam !== "org"
      ? new AppUrlPath(tenantId).getAgendaPath(agendaId)
      : "";

  return (
    <Link
      className="block hover:underline"
      to={path}
    >{`${!agendaId ? "No Agenda Attached" : agenda?.name ?? "..."}`}</Link>
  );
};
